import defaultReducer from "./defaultReducer";

const initialState = {
  open: false,
  selectedSite: {
    siteId: null,
    siteDisplay: "",
  },
  isSiteVariance: false,
  operator: null,
  selectedVarianceType: null,
};

export default defaultReducer("REVENUE_MODAL", initialState);
